export class Dac6ReporterModel {
  code: string;
  name: string;
  isO3: string;
  isO2: string;
  irs: string;
  isGroup: boolean;
  id: string;
  companyId: string;
  projectId: string;
}
export  class FileAttachmentModel {
  attachmentId: string;
  attachmentTitle: string;
  attachmentType: string;
}


